'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('external.success',{
    views: {
      'externalContent': {
        component: 'success'
      }
    },
})
}



// WEBPACK FOOTER //
// ./client/app/features/success/success.routes.js